import { render } from "./ContractsPage.vue?vue&type=template&id=15618eb8&scoped=true"
import script from "./ContractsPage.vue?vue&type=script&lang=js"
export * from "./ContractsPage.vue?vue&type=script&lang=js"

import "./ContractsPage.vue?vue&type=style&index=0&id=15618eb8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15618eb8"]])

export default __exports__